import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { BottomSheetContentLayout, Button, Column, Row, Switch, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useIoContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import styles from './BiometricLoginSheet.module.scss';
import { useBiometricLoginToggle } from './useBiometricLoginToggle';
export const GetBiometricLoginSheetTID = (parentTestId)=>getTestIds(parentTestId);
export const BiometricLoginSheet = (param)=>{
    let { testId = '' } = param;
    const { BiometricLoginSheetTestIds } = useMemo(()=>GetBiometricLoginSheetTID(testId), [
        testId
    ]);
    const { setupNeeded, checked, loading, method, onToggle } = useBiometricLoginToggle({
        success: BiometricLoginSheetTestIds.SuccessToast(),
        error: BiometricLoginSheetTestIds.ErrorToast()
    });
    const { t: profileTexts } = useLocaleKeys('pages.profile');
    const { native } = useIoContext();
    return /*#__PURE__*/ _jsx(BottomSheetContentLayout, {
        header: {
            title: profileTexts.biometricSecurity.title()
        },
        children: /*#__PURE__*/ _jsx(Column, {
            gap: 8,
            testId: BiometricLoginSheetTestIds.Root(),
            className: styles.content,
            children: setupNeeded ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: BiometricLoginSheetTestIds.SetupDescription(),
                        variant: "paragraph3",
                        skin: "secondary",
                        children: profileTexts.biometricSecurity.setupNeededDescription({
                            method
                        })
                    }),
                    native.platform === 'ios' ? /*#__PURE__*/ _jsx(Typography, {
                        testId: BiometricLoginSheetTestIds.IosInstruction(),
                        variant: "paragraph3",
                        skin: "secondary",
                        children: profileTexts.biometricSecurity.iosSetupInstruction({
                            method
                        })
                    }) : /*#__PURE__*/ _jsx(Button, {
                        testId: BiometricLoginSheetTestIds.OpenSettingsButton(),
                        bi: {
                            name: 'biometric_setup_open_settings'
                        },
                        skin: "primaryOutline",
                        fluid: true,
                        onClick: ()=>void native.biometric.openEnrollmentSettings(),
                        children: profileTexts.biometricSecurity.openDeviceSettings()
                    })
                ]
            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs(Row, {
                        gap: 12,
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                className: styles.label,
                                children: profileTexts.biometricSecurity.toggleLabel({
                                    method
                                })
                            }),
                            /*#__PURE__*/ _jsx(Switch, {
                                testId: BiometricLoginSheetTestIds.Toggle(),
                                bi: {
                                    name: 'biometric_login_toggle'
                                },
                                checked: checked,
                                loading: loading,
                                onChange: (_event, next)=>{
                                    void onToggle(next);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph3",
                        skin: "secondary",
                        children: profileTexts.biometricSecurity.description({
                            method
                        })
                    })
                ]
            })
        })
    });
};
